import React, { useState, useEffect } from 'react';
import { WithStyles } from '@material-ui/core/styles';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import { useQuery } from '@apollo/client';

import { withStyles } from '@material-ui/core';

import Dashboard from '../../../../layouts/Dashboard';
import ListVouchers from '../../../../components/Global/Vouchers/List';

import { voucherCodesInitQuery, Location } from './queries';

import styles from './styles';

interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  classes: ClassNameMap<string>;
}

const ListVouchersOrg = ({ classes, history }: Props): React.ReactElement => {
  const [location, setLocation] = useState<Location>({
    currency: '',
    locale: '',
    voucher_codes: [],
  });

  const { data: voucherCodesInitData } = useQuery(voucherCodesInitQuery(), { fetchPolicy: 'no-cache' });

  useEffect(() => {
    let mounted = true;
    if (mounted && voucherCodesInitData) {
      setLocation(voucherCodesInitData.locations[0]);
    }
    return () => {
      mounted = false;
    };
  }, [voucherCodesInitData]);

  const handleCreate = () => {
    history.push(`/loc/vouchers/create`);
  };

  const handleEdit = (id: string) => {
    history.push(`/loc/vouchers/${id}/edit`);
  };

  return (
    <Dashboard breadcrumbs={[{ label: 'Vouchers' }]}>
      <ListVouchers vouchers={location.voucher_codes} locale={location.locale} currency={location.currency} handleCreate={handleCreate} handleEdit={handleEdit} />
    </Dashboard>
  );
};

export default withRouter(withStyles(styles)(ListVouchersOrg));
